import { Box, Button, Icon, Text } from '@zillow/constellation-10';
import { IconTourDoorFilled } from '@zillow/constellation-icons';

type SetTourAvailabilityPromptProps = {
  tourCalendarPath: string;
  onClick?: () => void;
  eventId?: string;
};

/**
 * Persistent empty state shown in the Upcoming Tours slot when a listing has touring enabled but
 * nothing renters can book yet (no upcoming availability, no booked tours). The CTA links to the
 * tour calendar — the same destination the Upcoming Tours widget uses — where availability is set.
 */
const SetTourAvailabilityPrompt = ({ tourCalendarPath, onClick, eventId }: SetTourAvailabilityPromptProps) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: '200',
      }}
    >
      <Icon size="xl" css={{ color: 'icon.accent.blue.hero' }} render={<IconTourDoorFilled />} />
      <Text asChild textStyle="body-lg-bold">
        <h2>No tours scheduled yet</h2>
      </Text>
      <Text css={{ color: 'text.subtle' }}>Set your tour availability so renters can book a tour.</Text>
      <Button asChild>
        <a href={tourCalendarPath} onClick={onClick} data-eventid={eventId}>
          Set tour availability
        </a>
      </Button>
    </Box>
  );
};

export default SetTourAvailabilityPrompt;
